<script lang='ts'>import { Popup } from 'framework7-svelte';
export let opened = false;
export let title = 'Instructions';
export let steps = [];
export let onClose;
let popup;
function close() {
    opened = false;
}
function handlePopupClosed() {
    close();
    if (onClose) {
        onClose();
    }
}
</script>

<Popup
  bind:this={popup}
  class={'instructions-popup'}
  backdropEl={'.instructions-popup-backdrop'}
  opened={opened}
  onPopupClosed={handlePopupClosed}
  closeByBackdropClick={true}
  closeOnEscape={true}
>
  <div class="instructions-content">
    <div class="instructions-header">
      <h2>{title}</h2>
      <button class="close-button" on:click={close}>✕</button>
    </div>
    <div class="instructions-body">
      {#each steps as step, index}
        <div class="instruction-step">
          <h3>Step {index + 1}: {step.title}</h3>
          <p>{step.description}</p>
        </div>
      {/each}
    </div>
  </div>
</Popup>
<div class="popup-backdrop instructions-popup-backdrop" on:click={close}/>

<style>.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 12500;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
}

:global(.instructions-popup.modal-in) ~ .popup-backdrop {
  opacity: 1;
  pointer-events: auto;
}

.instructions-content {
  padding: 5vw;
  background-color: white;
  height: 100%;
  overflow-y: auto;
}

.instructions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5vw;
  border-bottom: 2px solid #283583;
  padding-bottom: 3vw;
}

.instructions-header h2 {
  font-size: 6vw;
  font-weight: bold;
  color: #283583;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  font-size: 8vw;
  color: #283583;
  cursor: pointer;
  padding: 0;
  width: 10vw;
  height: 10vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

.instructions-body {
  display: flex;
  flex-direction: column;
  grid-gap: 5vw;
  gap: 5vw;
}

.instruction-step {
  padding: 4vw;
  background-color: #f5f5f5;
  border-radius: 15px;
  border-left: 4px solid #FFCC00;
}

.instruction-step h3 {
  font-size: 4.5vw;
  font-weight: bold;
  color: #283583;
  margin: 0 0 2vw 0;
}

.instruction-step p {
  font-size: 3.5vw;
  color: #333;
  margin: 0;
  line-height: 1.5;
}</style>
